import { DEFAULT_POPUP_ERROR_MESSAGE_LIST } from "@/components/popup/error/PopupError";
import { PopupMessageList } from "@/components/popup/message/PopupMessage";
import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";
import { OverlayScrollbars } from "overlayscrollbars";

interface GlobalStoreInterface {
  rootScrollbar: OverlayScrollbars | null;
  isShowingPopupError: boolean;
  popupErrorMessageList: PopupMessageList;
  globalActions: {
    initRootScrollbar: (rootScrollbar: OverlayScrollbars) => void;
    clearRootScrollbar: () => void;
    showPopupError: (messageList?: PopupMessageList) => void;
    resetPopupError: () => void;
  };
}

const useGlobalStore = create<GlobalStoreInterface>((set, get) => ({
  rootScrollbar: null,
  isShowingPopupError: false,
  popupErrorMessageList: DEFAULT_POPUP_ERROR_MESSAGE_LIST,
  globalActions: {
    initRootScrollbar: (rootScrollbar: OverlayScrollbars) =>
      set({ rootScrollbar }),
    clearRootScrollbar: () => {
      get().rootScrollbar?.destroy();
      set({ rootScrollbar: null });
    },
    showPopupError: (messageList) =>
      set(() => ({
        isShowingPopupError: true,
        popupErrorMessageList: messageList || DEFAULT_POPUP_ERROR_MESSAGE_LIST,
      })),
    resetPopupError: () =>
      set(() => ({
        isShowingPopupError: false,
      })),
  },
}));

export default useGlobalStore;
export const useGlobalActions = () =>
  useGlobalStore((state) => state.globalActions);
export const usePopupError = () =>
  useGlobalStore(
    useShallow((state) => ({
      isShowingPopupError: state.isShowingPopupError,
      popupErrorMessageList: state.popupErrorMessageList,
    })),
  );
